module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAgCAMAAAA7dZg3AAAASFBMVEUAAADV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXk2KSQAAAAF3RSTlMAd2a0aTzMIlUTqKHi+Ip0OCnr2LI1HwXCUkkAAABeSURBVCjP7dM7EoAgDEXRgKhAUPGb/e/UDPXDsbBxhtPeIikSouAMsKxakkDTSVaiBWZhMuII6KVr6XfJjIAvCSspDcD+wYbBqwumQ9QGU+YY2b+b5aqHXX+H/PBEN+2FD+RZXZapAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_common/tel.png
// module id = lUxW
// module chunks = 1